import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=bf779ab4&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=bf779ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf779ab4",
  null
  
)

export default component.exports